import './App.css';
import LandingPage from './Components/LandingPage';
import AboutPage from './Components/AboutPage';
import JobPage from './Components/JobPage';
import FeedbackPage from './Components/FeedbackPage';
import Accordion from './Components/Accordion';
import Footer from './Components/Footer';

function App() {
  return (
    <>
  <LandingPage/>
  <AboutPage/>
  <JobPage/>
  <FeedbackPage/>
  <Accordion/>
  <Footer/>
    </>
  );
}

export default App;
